import { render, staticRenderFns } from "./Broadcast_Tukang.vue?vue&type=template&id=16f1ff97&scoped=true&"
import script from "./Broadcast_Tukang.vue?vue&type=script&lang=js&"
export * from "./Broadcast_Tukang.vue?vue&type=script&lang=js&"
import style0 from "./Broadcast_Tukang.vue?vue&type=style&index=0&id=16f1ff97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f1ff97",
  null
  
)

export default component.exports